import React from "react";
import { Ets2AffidavitPlaceOfDeliveryDTO } from "../dtos/Ets2AffidavitPlaceOfDeliveryDTO";
import { useTranslation } from "react-i18next";
import Ets2PlaceOfDeliveryStatusLabel from "./Ets2PlaceOfDeliveryStatusLabel";
import IContentDialogService from "features/shared/components/contentDialog/IContentDialogService";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import Ets2AffidavitExceptionSubDialog from "./Ets2AffidavitExceptionSubDialog";
import DocumentDownloadButton from "features/shared/components/documents/DocumentDownloadButton";
import RoundButton from "features/shared/components/buttons/RoundButton";
import { Ets2PlaceOfDeliveryStatus } from "../enums/ets2PlaceOfDeliveryStatus";

interface Props {
  pod: Ets2AffidavitPlaceOfDeliveryDTO;
}

const Ets2AffidavitPlaceOfDelivery = ({ pod }: Props) => {
  // translations
  const tLabels = useTranslation("ets2\\ets2").t;

  // DI
  const dialogService = useInjection<IContentDialogService>(IocTypes.ContentDialogService);

  // sub-renders
  const renderStatus = () => { 
    if (pod.ets2PlaceOfDeliveryStatus) {
      return <Ets2PlaceOfDeliveryStatusLabel status={pod.ets2PlaceOfDeliveryStatus} />;
    } else {
      return <>-</>;
    }
  }

  const renderRejectionReason = () => {
    if (!pod.rejectionReason) {
      return <>-</>;
    }
    return (
      <div className="text-truncate"> {pod.rejectionReason}</div>
    );
  };

  const getExceptionDialogTitle = () => {
    if (pod.ets2PlaceOfDeliveryStatus === Ets2PlaceOfDeliveryStatus.Rejected) {
      return "ets2AffidavitExceptionSubDialog.detailRejected";
    }
    if (pod.ets2PlaceOfDeliveryStatus === Ets2PlaceOfDeliveryStatus.Approved) {
      return "ets2AffidavitExceptionSubDialog.detailApproved";
    }
    return "";
  };

  const openExceptionDetailHandler = () => {
    dialogService.openDialog(tLabels(getExceptionDialogTitle()), () => <Ets2AffidavitExceptionSubDialog pod={pod} />);
  };

  const renderExceptionBtn = () => { 
    if (pod.exceptionType || pod.rejectionReason) {
      return <RoundButton onClickHandler={openExceptionDetailHandler} />
    } else {
      return null;
    }
  }

  const renderDownloadBtn = () => {
    if (!pod.document) {
      return null;
    }

    return (
      <div className="mr-2">
        <DocumentDownloadButton
          id={pod.placeOfDelivery ?? ""}
          icon="file-pdf"
          documents={[pod.document]}
        />
      </div>
    );
  };

    // render
  return (
    <div className="row no-gutters align-items-center py-1 py-sm-2">
      <div className="col col-sm-3">
        {pod.placeOfDelivery}
        <div className="d-sm-none">
          {renderStatus()}
        </div>
      </div>
      <div className="d-none d-sm-block col-sm-2">
        {renderStatus()}
      </div>
      <div className="d-none d-sm-block col-sm-5">
        {renderRejectionReason()}
      </div>
      <div className="col-auto col-sm-2 text-right">
        <div className="d-flex flex-row align-items-center justify-content-end">
          {renderDownloadBtn()}
          {renderExceptionBtn()}
        </div>
      </div>
    </div>
  );
};

export default Ets2AffidavitPlaceOfDelivery;
